import { getFormatRgbaColor } from '@/utils/functions/utils'

interface Props {
  image?: StrapiImageFile
  themeColor: string
}

const getDecoratorColor = (value: string) => {
  const usedColors = [
    'rgba(255,215,102,1)',
    'rgba(255,128,183,1)',
    'rgba(32,223,120,1)',
    'rgba(183,142,240,1)',
    'rgba(128,237,255,1)'
  ]
  return usedColors.filter(ele => ele !== value)
}

function InfluencerImage({ image, themeColor }: Props): JSX.Element {
  const decoratorColors = getDecoratorColor(getFormatRgbaColor(themeColor))

  return (
    <svg
      width="473"
      height="381"
      viewBox="0 0 473 381"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="max-w-full h-auto"
    >
      <rect
        x="380.453"
        y="29.2285"
        width="74.875"
        height="320.234"
        rx="37.4375"
        fill={decoratorColors[0]}
      />
      <path
        d="M419.328 190.022C419.328 294.968 332.862 380.043 226.201 380.043C119.54 380.043 33.0747 294.968 33.0747 190.022C33.0747 85.0756 119.54 0 226.201 0C332.862 0 419.328 85.0756 419.328 190.022Z"
        fill="#FBF9F4"
      />
      <path d="M419.328 190.022C419.328 294.968 332.862 380.043 226.201 380.043C119.54 380.043 33.0747 294.968 33.0747 190.022C33.0747 85.0756 119.54 0 226.201 0C332.862 0 419.328 85.0756 419.328 190.022Z" />
      <circle cx="38.2096" cy="239.824" r="21.6598" fill={decoratorColors[1]} />
      <circle cx="38.2096" cy="239.824" r="21.6598" />
      <path
        d="M41.9695 81.6011L78.0401 144.64H5.89898L41.9695 81.6011Z"
        fill={decoratorColors[2]}
      />
      <rect
        x="435.746"
        y="134.053"
        width="36.4797"
        height="36.4797"
        fill={decoratorColors[3]}
      />
      <circle
        cx="457.253"
        cy="277.664"
        r="14.263"
        strokeWidth="2.96893"
        stroke="black"
      />
      <mask
        id="mask0_1117_2971"
        maskUnits="userSpaceOnUse"
        x="33"
        y="0"
        width="388"
        height="381"
      >
        <ellipse
          cx="226.891"
          cy="190.235"
          rx="193.229"
          ry="189.809"
          fill="#ffffff"
        />
      </mask>
      <ellipse
        cx="226.891"
        cy="190.235"
        rx="193.229"
        ry="189.809"
        fill={decoratorColors[4]}
      />
      <g mask="url(#mask0_1117_2971)">
        <rect
          x="-27.0073"
          y="-25.1895"
          width="506.404"
          height="407.404"
          fill="url(#pattern2)"
        />
        <rect
          x="-27.0073"
          y="-25.1895"
          width="506.404"
          height="407.404"
          fill="url(#pattern1)"
        />
        <rect
          x="-27.0073"
          y="-25.1895"
          width="506.404"
          height="407.404"
          fill="url(#pattern2)"
        />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1117_2971"
            transform="translate(-0.00323769) scale(0.00112834 0.00140252)"
          />
        </pattern>
        <pattern
          id="pattern1"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1117_2971"
            transform="translate(-0.00323769) scale(0.00112834 0.00140252)"
          />
        </pattern>
        <pattern
          id="pattern2"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_1117_2971"
            transform="translate(-0.00323769) scale(0.00112834 0.00140252)"
          />
        </pattern>

        {/* TODO: optimize image using Image component */}
        <image
          id="image0_1117_2971"
          className="object-cover rounded-full"
          xlinkHref={image?.url}
          width="892"
          height="713"
          key={image?.url}
        />
      </defs>
    </svg>
  )
}

export default InfluencerImage
